import { Grid, Typography } from "@mui/material"
import { Link } from "react-router-dom"

interface DisplayFieldProps {
  title: string,
  text?: string,
  fill?: number,
  link?: boolean,
  textColor?: string,
  bordered?: boolean
}

const DisplayField: React.FC<DisplayFieldProps> = ({ title, text, fill, link, textColor, bordered }) => {
  return (<>
    <Grid 
      item 
      xs={fill || 4} 
      sm={fill || 4} 
      md={fill || 4}
      sx={bordered ? { border: '1px solid #e0e0e0', padding: 1 } : {}}
    >
      <Typography sx={{ fontSize: "12px", }} variant="subtitle2">{title}</Typography>
      {
        link !== undefined
          ? <Typography component={Link} to={text || "#"} sx={{ wordWrap: "break-word", color: textColor }} variant="h6">{text || ""}</Typography>
          : <Typography sx={{ wordWrap: "break-word", color: textColor }} variant="h6">{text || ""}</Typography>
      }
    </Grid>
  </>)
}

export default DisplayField
